/* eslint-disable import/no-cycle */
// Utils
import { isObject } from 'ezyvet-fe-helpers';
import { removeValuesForArrayRecursive } from './removeValuesForArrayRecursive';
import { removeValuesForObjectRecursive } from './removeValuesForObjectRecursive';
/**
 * Remove all of the defined values from the given value and nested values, will return undefined if
 * the given value is one of the values to remove.
 *
 * @param {any} value
 * @param {any[]} toRemove
 *
 * @return {any}
 */
export var removeValuesRecursive = function (value, toRemove) {
    var newValue = value;
    if (toRemove.includes(value)) {
        newValue = undefined;
    }
    else if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        newValue = removeValuesForArrayRecursive(value, toRemove);
    }
    else if (isObject(value)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        newValue = removeValuesForObjectRecursive(value, toRemove);
    }
    return newValue;
};
//# sourceMappingURL=removeValuesRecursive.js.map